export const UserApiPermissionHelpers = (code: string, userApiPermission: Array<string>) => {
  return userApiPermission.includes(code);
};
